import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Inject,
  Input,
  HostListener,
} from "@angular/core";
import { FilteringGuide } from "../models/filteringGuide";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { StandardService } from "../services/standard.service";
import { ActivatedRoute } from "@angular/router";
import { LocationType } from "../models/location-type";
import { StandardListType, FilteringEnum } from "../core/constant";
import { sortWithSelectedFirst, shouldShowSelectedDivider } from "../core/filter-utils";
import { EquipmentType } from "../models/equipment-type";
import { SubLocationType } from "../models/sub-location-type";
import { FilterList } from "../models/filterList";
import { eventListeners } from "@popperjs/core";
import { CryptographyService } from "../services/cryptography.service";

@Component({
  selector: "app-location-type-filter",
  templateUrl: "./location-type-filter.component.html",
  styleUrls: ["./location-type-filter.component.scss"],
})
export class LocationTypeFilterComponent implements OnInit {
  searchKey: string = "";
  selectedCountryId: number = 0;
  ExportselectedCountryIds: any[] = [];

  isLocationDropdownOpen: boolean = false;
  locationSearchText: string = "";
  filteredLocations: any[] = [];

  isequipmentTypesDropdownOpen: boolean = false;
  equipmentTypesSearchText: string = "";
  filteredequipmentTypes: any[] = [];

  isCountryDropdownOpen: boolean = false;
  countrySearchText: string = "";
  filteredCountries: any[] = [];

  locationId: number = 0;
  panelOpenState: boolean = false;
  locationTypes: LocationType[] = [];
  subLcationTypes: SubLocationType[] = [];
  subLcationTypesAll: SubLocationType[] = [];
  equipmentTypes: EquipmentType[] = [];
  equipmentTypesAll: EquipmentType[] = [];
  filterList: FilteringGuide[] = [];
  filteringForCheckBox: FilteringGuide[] = [];
  exportFilterList: FilteringGuide[] = [];

  isExportModalOpen: boolean = false;

  isExportEquipmentTypeDropdownOpen: boolean = false;
  isExportLocationDropdownOpen: boolean = false;
  isExportCountryDropdownOpen: boolean = false;

  userRole: number;

  @Input() standardFiltration: FilterList = new FilterList();
  @Output() messageEvent = new EventEmitter<Array<FilteringGuide>>();
  @Output() searchApplied = new EventEmitter<string>();
  @Output() countrySelected = new EventEmitter<any>();
  @Output() exportListFilter = new EventEmitter<Array<FilteringGuide>>();
  @Output() countryListFilter = new EventEmitter<any>();
  @Input() searchKeyFromParent: string = "";
  @Output() exportClicked = new EventEmitter<void>();
  @Input() allCountries: any;
  @Input() standardListType: number;
  constructor(
    private activeRoute: ActivatedRoute,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
    private standardService: StandardService,
    private cryptographyService: CryptographyService,
  ) { }

  ngOnInit() {
    this.userRole = sessionStorage.getItem("userRoleId")
      ? this.cryptographyService.decryptData(
        sessionStorage.getItem("userRoleId"),
      )
      : this.cryptographyService.decryptData(this.storage.get("userRole"));
    this.getAllStandardTypes();
  }

  getAllStandardTypes(): void {
    this.locationId = parseInt(
      this.activeRoute.snapshot.paramMap.get("locationId"),
    );
    const filterList = this.standardFiltration || new FilterList();
    if (this.standardListType != null) {
      filterList.standardListType = this.standardListType;
    }
    this.standardService
      .getEquipmentStandardChipset(filterList)
      .subscribe((data: any) => {
        this.locationTypes = (data?.locationTypes || []).map(
          (o) => new LocationType(o),
        );
        this.equipmentTypes = (data?.equipmentTypes || []).map(
          (o) => new EquipmentType(o),
        );
        this.setFilteredEquipmentTypes([...this.equipmentTypes]);
        this.setFilteredLocations([...this.locationTypes]);
      });
  }

  private setFilteredLocations(items: any[]): void {
    this.filteredLocations = sortWithSelectedFirst(items, (id) =>
      !!this.setCheckedStateForCheckBoxes(
        FilteringEnum.FilterByLocationType,
        id,
      ),
    );
  }

  private setFilteredEquipmentTypes(items: any[]): void {
    this.filteredequipmentTypes = sortWithSelectedFirst(items, (id) =>
      !!this.setCheckedStateForCheckBoxes(
        FilteringEnum.FilterByEquipmentType,
        id,
      ),
    );
  }

  private setFilteredCountries(items: any[]): void {
    this.filteredCountries = sortWithSelectedFirst(
      items,
      (id) => id === this.selectedCountryId,
    );
  }

  private setExportFilteredLocations(items: any[]): void {
    this.filteredLocations = sortWithSelectedFirst(items, (id) =>
      !!this.setExportCheckedStateForCheckBoxes(
        FilteringEnum.FilterByLocationType,
        id,
      ),
    );
  }

  private setExportFilteredEquipmentTypes(items: any[]): void {
    this.filteredequipmentTypes = sortWithSelectedFirst(items, (id) =>
      !!this.setExportCheckedStateForCheckBoxes(
        FilteringEnum.FilterByEquipmentType,
        id,
      ),
    );
  }

  private setExportFilteredCountries(items: any[]): void {
    this.filteredCountries = sortWithSelectedFirst(items, (id) =>
      this.ExportselectedCountryIds.includes(id),
    );
  }

  private refreshFilteredListForFilterParam(filterParam: number): void {
    if (
      filterParam === FilteringEnum.FilterByLocationType &&
      this.isLocationDropdownOpen
    ) {
      this.filterLocations();
    } else if (
      filterParam === FilteringEnum.FilterByEquipmentType &&
      this.isequipmentTypesDropdownOpen
    ) {
      this.filterEquipmentTypes();
    }
  }

  private refreshExportFilteredListForFilterParam(filterParam: number): void {
    if (
      filterParam === FilteringEnum.FilterByLocationType &&
      this.isExportLocationDropdownOpen
    ) {
      this.setExportFilteredLocations([...this.locationTypes]);
    } else if (
      filterParam === FilteringEnum.FilterByEquipmentType &&
      this.isExportEquipmentTypeDropdownOpen
    ) {
      this.setExportFilteredEquipmentTypes([...this.equipmentTypes]);
    }
  }

  addFilter($event, id, filterParam, name, type) {
    this.sendAuthEvent(name, id, type, $event.checked);
    //debugger;
    if (this.getFilter(this.standardListType) != null) {
      this.filterList = this.getFilter(this.standardListType);
    }
    if ($event && FilteringEnum.FilterByLocationType === filterParam) {
      //this.setEquipmentTypes(id, $event.checked);
      //this.setSubLocationTypes(id, $event.checked);
    }

    if ($event.checked) {
      let filterGuide = this.filterList.find((i) => i.type === filterParam);
      if (filterGuide != undefined) {
        if (!filterGuide.ids.includes(id)) {
          filterGuide.ids.push(id);
        }
      } else {
        let guide = new FilteringGuide();
        guide.type = filterParam;
        guide.ids.push(id);
        this.filterList.push(guide);
      }
    } else {
      let selectedFilter = this.filterList.find((i) => i.type === filterParam);
      if (selectedFilter != undefined && selectedFilter.ids.includes(id)) {
        let index = selectedFilter.ids.indexOf(id);
        selectedFilter.ids.splice(index, 1);
      }
      if (selectedFilter.ids.length == 0) {
        let i = this.filterList.findIndex((x) => x.type === filterParam);
        this.filterList.splice(i, 1);
      }
    }
    this.setFilter(this.standardListType, this.filterList);
    this.refreshFilteredListForFilterParam(filterParam);
    // this.messageEvent.emit(this.filterList);
  }

  setEquipmentTypes(locationId, isAdd) {
    let toAdd = this.locationTypes.filter((c) => c.id === locationId)[0]
      .equipmentTypes;
    if (toAdd) {
      if (isAdd) {
        if (this.equipmentTypes.length > 0) {
          this.equipmentTypesAll = this.equipmentTypesAll.concat(toAdd);
          this.equipmentTypes = Array.from(
            new Set(this.equipmentTypesAll.map((s) => s.id)),
          ).map((id) => {
            return {
              id: id,
              name: this.equipmentTypesAll.find((s) => s.id === id).name,
              description: "",
              equipmentTypeLocationMappings: [],
            };
          });
        } else {
          this.equipmentTypes = toAdd.map((o) => new EquipmentType(o));
          this.equipmentTypesAll = toAdd.map((o) => new EquipmentType(o));
        }
      } else {
        toAdd.forEach((c) => {
          let toBeRemovedIndex = this.equipmentTypesAll.findIndex(
            (x) => x.id == c.id,
          );
          let itemCount = this.equipmentTypesAll.filter(
            (x) => x.id == c.id,
          ).length;
          if (itemCount == 1) {
            let selectedFilter = this.filterList.find(
              (i) => i.type === FilteringEnum.FilterByEquipmentType,
            );
            if (
              selectedFilter != undefined &&
              selectedFilter.ids.includes(c.id)
            ) {
              let index = selectedFilter.ids.indexOf(c.id);
              if (index > -1) {
                selectedFilter.ids.splice(index, 1);
              }
            }
            if (selectedFilter && selectedFilter.ids.length == 0) {
              let i = this.filterList.findIndex(
                (x) => x.type === FilteringEnum.FilterByEquipmentType,
              );
              this.filterList.splice(i, 1);
            }
          }
          this.equipmentTypesAll.splice(toBeRemovedIndex, 1);
        });

        this.equipmentTypes = Array.from(
          new Set(this.equipmentTypesAll.map((s) => s.id)),
        ).map((id) => {
          return {
            id: id,
            name: this.equipmentTypesAll.find((s) => s.id === id).name,
            description: "",
            equipmentTypeLocationMappings: [],
          };
        });
      }
    }
  }

  setSubLocationTypes(locationId, isAdd) {
    let toAdd = this.locationTypes.filter((c) => c.id === locationId)[0]
      .subLocationTypes;
    if (toAdd) {
      if (isAdd) {
        if (this.subLcationTypes.length > 0) {
          this.subLcationTypesAll = this.subLcationTypesAll.concat(toAdd);
          this.subLcationTypes = Array.from(
            new Set(this.subLcationTypesAll.map((s) => s.id)),
          ).map((id) => {
            return {
              id: id,
              name: this.subLcationTypesAll.find((s) => s.id === id).name,
              locationTypeId: this.subLcationTypesAll.find((s) => s.id === id)
                .locationTypeId,
            };
          });
        } else {
          this.subLcationTypes = toAdd.map((o) => new SubLocationType(o));
          this.subLcationTypesAll = toAdd.map((o) => new SubLocationType(o));
        }
      } else {
        toAdd.forEach((c) => {
          let toBeRemovedIndex = this.subLcationTypesAll.findIndex(
            (x) => x.id == c.id,
          );
          let itemCount = this.subLcationTypesAll.filter(
            (x) => x.id == c.id,
          ).length;
          if (itemCount == 1) {
            let selectedFilter = this.filterList.find(
              (i) => i.type === FilteringEnum.FilterBySubLocationType,
            );
            if (
              selectedFilter != undefined &&
              selectedFilter.ids.includes(c.id)
            ) {
              let index = selectedFilter.ids.indexOf(c.id);
              if (index > -1) {
                selectedFilter.ids.splice(index, 1);
              }
            }
            if (selectedFilter && selectedFilter.ids.length == 0) {
              let i = this.filterList.findIndex(
                (x) => x.type === FilteringEnum.FilterBySubLocationType,
              );
              this.filterList.splice(i, 1);
            }
          }
          this.subLcationTypesAll.splice(toBeRemovedIndex, 1);
        });
        this.subLcationTypes = Array.from(
          new Set(this.subLcationTypesAll.map((s) => s.id)),
        ).map((id) => {
          return {
            id: id,
            name: this.subLcationTypesAll.find((s) => s.id === id).name,
            locationTypeId: this.subLcationTypesAll.find((s) => s.id === id)
              .locationTypeId,
          };
        });
      }
    }
  }

  setCheckedStateForCheckBoxes(type, id) {
    this.filteringForCheckBox = this.getFilter(this.standardListType);
    if (this.filteringForCheckBox != null) {
      let t = this.filteringForCheckBox.find((i) => i.type === type);
      if (t != undefined && t.ids.includes(id)) {
        return true;
      }
    }
  }

  getFilter(standardListType: number) {
    switch (standardListType) {
      case StandardListType.GlobalEquipment: {
        return this.standardService.equipmentStandardFiltration.filterSet;
      }
      case StandardListType.NationalEquipment: {
        return this.standardService.nationalEquipmentStandardFiltration
          .filterSet;
      }
      case StandardListType.Obsolete: {
        return this.standardService.obsoleteStandardFiltration.filterSet;
      }
      default: {
        break;
      }
    }
  }

  setFilter(standardListType: number, filterList: FilteringGuide[]) {
    switch (standardListType) {
      case StandardListType.GlobalEquipment: {
        return (this.standardService.equipmentStandardFiltration.filterSet =
          filterList);
      }
      case StandardListType.NationalEquipment: {
        return (this.standardService.nationalEquipmentStandardFiltration.filterSet =
          filterList);
      }
      case StandardListType.Obsolete: {
        return (this.standardService.obsoleteStandardFiltration.filterSet =
          filterList);
      }
      default: {
        break;
      }
    }
  }
  async sendAuthEvent(filterName, filterID, filterType, isChecked) {
    this.standardService
      .recordSearchEvent([
        {
          eventType: "GRSFilters",
          filterName: filterName,
          filterID: filterID,
          filterType: filterType,
          isChecked: isChecked,
          session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
        },
      ])
      .subscribe({ next: () => void 0, error: () => void 0 });
  }

  toggleDropdown(dropdownType: "country" | "location" | "equipment") {
    if (dropdownType === "country") {
      this.isLocationDropdownOpen = false;
      this.isequipmentTypesDropdownOpen = false;
    } else if (dropdownType === "location") {
      this.isCountryDropdownOpen = false;
      this.isequipmentTypesDropdownOpen = false;
    } else if (dropdownType === "equipment") {
      this.isCountryDropdownOpen = false;
      this.isLocationDropdownOpen = false;
    }

    switch (dropdownType) {
      case "country":
        this.isCountryDropdownOpen = !this.isCountryDropdownOpen;

        this.countrySearchText = "";

        this.setFilteredCountries(this.allCountries ? [...this.allCountries] : []);

        break;

      case "location":
        this.isLocationDropdownOpen = !this.isLocationDropdownOpen;

        this.locationSearchText = "";

        this.setFilteredLocations([...this.locationTypes]);

        break;

      case "equipment":
        this.isequipmentTypesDropdownOpen = !this.isequipmentTypesDropdownOpen;

        this.equipmentTypesSearchText = "";

        this.setFilteredEquipmentTypes([...this.equipmentTypes]);

        break;
    }
  }

  filterLocations() {
    const searchTerm = this.locationSearchText.toLowerCase();
    this.setFilteredLocations(
      this.locationTypes.filter((location) =>
        location.name.toLowerCase().includes(searchTerm),
      ),
    );
  }

  closeLocationDropdown() {
    this.isLocationDropdownOpen = false;
  }

  filterEquipmentTypes() {
    const searchTerm = this.equipmentTypesSearchText.toLowerCase();
    this.setFilteredEquipmentTypes(
      this.equipmentTypes.filter((type) =>
        type.name.toLowerCase().includes(searchTerm),
      ),
    );
  }

  filterCountries() {
    const searchTerm = this.countrySearchText.toLowerCase();
    this.setFilteredCountries(
      this.allCountries.filter((location) =>
        location.name.toLowerCase().includes(searchTerm),
      ),
    );
  }

  closeEquipmentTYpeDropdown() {
    this.isequipmentTypesDropdownOpen = false;
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Close location dropdown
    if (!target.closest(".mcd-filter-dropdown-wrapper")) {
      this.isLocationDropdownOpen = false;
    }
    if (!target.closest(".mcd-filter-dropdown-wrapper")) {
      this.isequipmentTypesDropdownOpen = false;
    }
    if (!target.closest(".mcd-filter-dropdown-wrapper")) {
      this.isCountryDropdownOpen = false;
    }
  }

  getSelectedItemsCount(type: "equipmentType" | "location" | "country"): any {
    let items: any[];

    let checkboxType: number;

    if (type === "equipmentType") {
      items = this.equipmentTypes;

      checkboxType = 4;
    } else if (type === "location") {
      items = this.locationTypes;

      checkboxType = 1;
    } else {
      return [];
    }

    return items

      .filter((item) =>
        this.setCheckedStateForCheckBoxes(checkboxType, item.id),
      )

      .map((item) => item.name);
  }

  // Single display text function

  getDisplayText(type: "equipmentType" | "location" | "country"): string {
    const selected = this.getSelectedItemsCount(type);

    if (selected.length === 0) return "";

    if (selected.length === 1) return `: ${selected[0]}`;

    return ` : ${selected[0]} +${selected.length - 1}`;
  }

  countryDisplayText(): string {
    const selected = this.allCountries.find(
      (item) => item.id === this.selectedCountryId,
    );
    return selected ? ": " + selected.name : "";
  }

  showFilterClearButton(
    type: "equipmentType" | "location" | "country",
  ): boolean {
    if (type === "country") {
      return this.shouldShowCountryClearButton();
    }
    return this.getSelectedItemsCount(type).length > 0;
  }

  shouldShowCountryClearButton(): boolean {
    if (!this.selectedCountryId) {
      return false;
    }
    const country = this.allCountries?.find(
      (c) => c.id === this.selectedCountryId,
    );
    if (country?.name?.toLowerCase() === "all countries") {
      return false;
    }
    return true;
  }

  shouldShowCountryFilterHighlight(): boolean {
    return (
      this.isCountryDropdownOpen || this.shouldShowCountryClearButton()
    );
  }

  closeFilterDropdown(
    type: "equipmentType" | "location" | "country",
  ): void {
    switch (type) {
      case "equipmentType":
        this.isequipmentTypesDropdownOpen = false;
        break;
      case "location":
        this.isLocationDropdownOpen = false;
        break;
      case "country":
        this.isCountryDropdownOpen = false;
        break;
    }
  }

  removeSelected(
    type: "equipmentType" | "location" | "country",
    event?: Event,
  ): void {
    event?.stopPropagation();
    event?.preventDefault();

    if (this.getFilter(this.standardListType) != null) {
      this.filterList = this.getFilter(this.standardListType);
    }

    this.closeFilterDropdown(type);

    if (type === "country") {
      const allCountriesItem =
        this.allCountries?.find(
          (c) =>
            c.id === 0 || c.name?.toLowerCase() === "all countries",
        ) ?? { id: 0, name: "All Countries" };
      this.selectedCountryId = allCountriesItem.id;
      this.countrySearchText = "";
      this.filteredCountries = this.allCountries
        ? [...this.allCountries]
        : [];
      this.setFilteredCountries(this.filteredCountries);
      this.countrySelected.emit(allCountriesItem);
      return;
    }

    let filterParam: number;
    if (type === "equipmentType") {
      filterParam = FilteringEnum.FilterByEquipmentType;
      this.equipmentTypesSearchText = "";
      this.setFilteredEquipmentTypes([...this.equipmentTypes]);
    } else {
      filterParam = FilteringEnum.FilterByLocationType;
      this.locationSearchText = "";
      this.setFilteredLocations([...this.locationTypes]);
    }

    const filterGuide = this.filterList.find((i) => i.type === filterParam);
    if (filterGuide) {
      const index = this.filterList.indexOf(filterGuide);
      if (index !== -1) {
        this.filterList.splice(index, 1);
      }
    }

    this.setFilter(this.standardListType, this.filterList);
    this.messageEvent.emit(this.filterList);
  }

  onSearch(key: any) {
    this.isLocationDropdownOpen = false;
    this.isequipmentTypesDropdownOpen = false;
    this.searchKey = key.value;
    this.searchApplied.emit(this.searchKey);
  }

  applyFilters() {
    this.isLocationDropdownOpen = false;
    this.isequipmentTypesDropdownOpen = false;
    this.messageEvent.emit(this.filterList);
  }

  onCountrySelect(item: any) {
    this.selectedCountryId = item.id;
    this.countrySelected.emit(item);
    this.isCountryDropdownOpen = false;
  }

  onExportClick() {
    this.exportListFilter.emit(this.exportFilterList);
  }

  openExportModal() {
    this.isExportModalOpen = !this.isExportModalOpen;
    if (this.isExportModalOpen) {
      this.setExportFilteredEquipmentTypes([...this.equipmentTypes]);
      this.setExportFilteredLocations([...this.locationTypes]);
      this.setExportFilteredCountries(
        this.allCountries ? [...this.allCountries] : [],
      );
    }
  }
  closeExportModal() {
    this.isExportModalOpen = false;
    this.isExportEquipmentTypeDropdownOpen = false;
    this.isExportCountryDropdownOpen = false;
    this.isExportLocationDropdownOpen = false;
  }

  toggleExportDropdown(dropdownType: "equipment" | "country" | "location") {
    // Close all other dropdowns first
    if (dropdownType !== "equipment") {
      this.isExportEquipmentTypeDropdownOpen = false;
    }
    if (dropdownType !== "country") {
      this.isExportCountryDropdownOpen = false;
    }
    if (dropdownType !== "location") {
      this.isExportLocationDropdownOpen = false;
    }

    // Toggle the requested dropdown
    switch (dropdownType) {
      case "equipment":
        this.isExportEquipmentTypeDropdownOpen =
          !this.isExportEquipmentTypeDropdownOpen;
        if (this.isExportEquipmentTypeDropdownOpen) {
          this.setExportFilteredEquipmentTypes([...this.equipmentTypes]);
        }
        break;

      case "location":
        this.isExportLocationDropdownOpen = !this.isExportLocationDropdownOpen;
        if (this.isExportLocationDropdownOpen) {
          this.setExportFilteredLocations([...this.locationTypes]);
        }
        break;
      case "country":
        this.isExportCountryDropdownOpen = !this.isExportCountryDropdownOpen;
        if (this.isExportCountryDropdownOpen) {
          this.setExportFilteredCountries([...this.allCountries]);
        }
        break;
    }
  }

  setExportCheckedStateForCheckBoxes(type, id): boolean {
    if (this.exportFilterList != null && this.exportFilterList.length > 0) {
      let t = this.exportFilterList.find((i) => i.type === type);
      if (t != undefined && t.ids.includes(id)) {
        return true;
      }
    }
    return false;
  }

  getExportSelectedItemsCount(
    type: "equipment" | "location" | "category",
  ): any {
    let items: any[];
    let checkboxType: number;

    if (type === "equipment") {
      items = this.equipmentTypes;
      checkboxType = 4;
    } else if (type === "location") {
      items = this.locationTypes;
      checkboxType = 1;
    }

    return items
      .filter((item) =>
        this.setExportCheckedStateForCheckBoxes(checkboxType, item.id),
      )
      .map((item) => item.name);
  }

  getExportDisplayText(type: "equipment" | "location" | "category"): string {
    const selected = this.getExportSelectedItemsCount(type);

    if (selected.length === 0) return "";
    if (selected.length === 1) return `${selected[0]}`;
    return `${selected[0]} +${selected.length - 1}`;
  }

  // Apply export filters and pass to API
  applyExportFilters() {
    this.isExportEquipmentTypeDropdownOpen = false;
    this.isExportLocationDropdownOpen = false;
    this.countryListFilter.emit(this.ExportselectedCountryIds.length > 0 ? this.ExportselectedCountryIds : []);
    this.exportListFilter.emit(this.exportFilterList);

    this.closeExportModal();
    this.exportFilterList = [];
    this.ExportselectedCountryIds = [];
  }

  addExportFilter($event, id, filterParam, name, type) {
    if ($event.checked) {
      let filterGuide = this.exportFilterList.find(
        (i) => i.type === filterParam,
      );
      if (filterGuide != undefined) {
        if (!filterGuide.ids.includes(id)) {
          filterGuide.ids.push(id);
        }
      } else {
        let guide = new FilteringGuide();
        guide.type = filterParam;
        guide.ids.push(id);
        this.exportFilterList.push(guide);
      }
    } else {
      let selectedFilter = this.exportFilterList.find(
        (i) => i.type === filterParam,
      );
      if (selectedFilter != undefined && selectedFilter.ids.includes(id)) {
        let index = selectedFilter.ids.indexOf(id);
        selectedFilter.ids.splice(index, 1);
      }
      if (selectedFilter && selectedFilter.ids.length == 0) {
        let i = this.exportFilterList.findIndex((x) => x.type === filterParam);
        if (i > -1) {
          this.exportFilterList.splice(i, 1);
        }
      }
    }
    this.refreshExportFilteredListForFilterParam(filterParam);
  }

  onCountrySelectionChange(event: any, countryId: any) {
    if (event.checked) {
      // Add to selected IDs if not already present
      if (!this.ExportselectedCountryIds.includes(countryId)) {
        this.ExportselectedCountryIds.push(countryId);
      }
    } else {
      // Remove from selected IDs
      const index = this.ExportselectedCountryIds.indexOf(countryId);
      if (index > -1) {
        this.ExportselectedCountryIds.splice(index, 1);
      }
    }
    console.log("Selected Country IDs:", this.ExportselectedCountryIds);
    if (this.isExportCountryDropdownOpen) {
      this.setExportFilteredCountries(
        this.allCountries ? [...this.allCountries] : [],
      );
    }
  }
  isCountrySelected(countryId: any): boolean {
    return this.ExportselectedCountryIds.includes(countryId);
  }

  getCountryDisplayText(): string {
    const country = this.filteredCountries.find(
      (c) => c.id === this.ExportselectedCountryIds[0],
    );

    if (this.ExportselectedCountryIds.length === 1) {
      return country.name;
    }

    return `${country.name} +${this.ExportselectedCountryIds.length - 1}`;
  }

  showFilterDivider(items: any[], index: number, filterType: number): boolean {
    return shouldShowSelectedDivider(items, index, (id) =>
      !!this.setCheckedStateForCheckBoxes(filterType, id),
    );
  }

  showCountryFilterDivider(items: any[], index: number): boolean {
    return shouldShowSelectedDivider(items, index, (id) =>
      id === this.selectedCountryId,
    );
  }

  showExportFilterDivider(
    items: any[],
    index: number,
    filterType: number,
  ): boolean {
    return shouldShowSelectedDivider(items, index, (id) =>
      this.setExportCheckedStateForCheckBoxes(filterType, id),
    );
  }

  showExportCountryFilterDivider(items: any[], index: number): boolean {
    return shouldShowSelectedDivider(items, index, (id) =>
      this.isCountrySelected(id),
    );
  }
}
